module.exports = __webpack_public_path__ + "img/jszyc.18f32b49.jpg";